import { v4 as uuidv4 } from 'uuid'

import { FILE_NAME, FILE_TYPE, FILE_URL, MEDIA_TYPE } from '../../../../../../ReusableFormFields/AdFileUpload/fields'
import { ASSET_ID } from '../../../../../../Google/AdForms/fields'
import { CLICK_THROUGH_LINK, MEDIA_HEIGHT, MEDIA_WIDTH } from '../../../../fields'
import { PAUSED, STATUS } from '../../../../../fields'
import { IS_QUARANTINE } from '../../../../../../reusableFields'

export const MEDIA_ITEMS = 'creatives'

export const initialDv360File = {
  [FILE_NAME]: '',
  [FILE_URL]: '',
  [FILE_TYPE]: '',
  [MEDIA_TYPE]: '',
  [ASSET_ID]: null,
  [MEDIA_WIDTH]: null,
  [MEDIA_HEIGHT]: null
}

export const initialDv360Media = {
  ...initialDv360File,
  // this is a temporary id for the media file uploading to avoid preview disappearing on other media files removal
  id: uuidv4()
}

export const getInitialValues = isInternalAdCreation => ({
  [IS_QUARANTINE]: isInternalAdCreation,
  [MEDIA_ITEMS]: [initialDv360Media],
  [STATUS]: PAUSED,
  [CLICK_THROUGH_LINK]: 'https://'
})
